module.exports = __webpack_public_path__ + "img/ico_point.3832c4c6.svg";